import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  ADD_ROLE,
  GET_ROLES,
  GET_ROLE_BY_ID,
  MODIFY_ROLE,
  SET_EDITING_ROLE,
  TOGGLE_ROLE,
  UPDATE_ROLE,
  SET_ROLES_FILTERS,
  SET_ROLES_PAGINATION,
} from 'roles/constants';

import { normalize, schema } from 'normalizr';

const role = new schema.Entity('roles');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['name'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  result: {},
  entities: {},
  editing: {
    name: '',
    permissions: [],
    isSaving: false,
    isLoading: false,
  },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const getFulfilled = (
  state,
  { payload: { page, limit, totalPages, records, totalDocs } }
) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    page,
    limit,
    totalPages,
    totalDocs,
  },
  ...normalize({ roles: records }, { roles: [role] }),
});

export const modifyRole = (state, { payload }) => ({
  ...state,
  editing: { ...state.editing, ...payload },
});

export const setEditingRole = (state) => ({
  ...state,
  editing: initialState.editing,
});

export const addPending = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: true },
});
export const addRejected = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});
export const addFulfilled = (state, { payload }) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});

export const updatePending = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: true },
});
export const updateRejected = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});
export const updateFulfilled = (state, { payload }) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    roles: {
      ...state.entities.roles,
      [meta.id]: { ...state.entities.roles[meta.id], isSaving: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    roles: {
      ...state.entities.roles,
      [meta.id]: { ...state.entities.roles[meta.id], isSaving: false },
    },
  },
});
export const toggleFulfilled = (state, { meta, payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    roles: {
      ...state.entities.roles,
      [meta.id]: { ...payload.user, isSaving: false },
    },
  },
});

export const getByIdPending = (state) => ({
  ...state,
  editing: { ...state.editing, isLoading: true },
});
export const getByIdRejected = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    isLoading: false,
  },
});
export const getByIdFulfilled = (state, { payload: { role } }) => {
  return {
    ...state,
    editing: {
      ...role,
      isLoading: false,
    },
  };
};

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: {
    ...state.pagination,
    ...payload,
  },
});

const roleReducers = {
  [GET_ROLES]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [GET_ROLE_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [ADD_ROLE]: {
    [PENDING]: addPending,
    [REJECTED]: addRejected,
    [FULFILLED]: addFulfilled,
  },
  [UPDATE_ROLE]: {
    [PENDING]: updatePending,
    [REJECTED]: updateRejected,
    [FULFILLED]: updateFulfilled,
  },
  [TOGGLE_ROLE]: {
    [PENDING]: togglePending,
    [REJECTED]: toggleRejected,
    [FULFILLED]: toggleFulfilled,
  },
  [SET_EDITING_ROLE]: setEditingRole,
  [MODIFY_ROLE]: modifyRole,
  [SET_ROLES_FILTERS]: setFilters,
  [SET_ROLES_PAGINATION]: setPagination,
};

export default TypeToReducer(roleReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/reducers/roles_reducers.js